import {gql} from '@apollo/client';

import {AntibodyFormat} from 'antibodies/AntibodyTypedefs';
import {QueryResultType, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

import {AntibodyFormatsQuery} from './__generated/AntibodyFormatsQuery';

export const ANTIBODY_FORMATS_QUERY = gql`
  query AntibodyFormatsQuery @skipAudit @engComponent(name: ANTIBODIES) {
    allAntibodyFormats {
      ...AntibodyFormatGraphQL
    }
  }
  ${getFragmentWrapper('AntibodyFormat').fragment}
`;

export type UseAntibodyFormatsQueryResult =
  | {
      status: QueryResultType.SUCCESS;
      antibodyFormats: Array<AntibodyFormat>;
      refetch: () => Promise<Array<AntibodyFormat>>;
    }
  | {
      status: QueryResultType.ERROR | QueryResultType.PENDING | QueryResultType.SKIPPED;
      antibodyFormats: null;
      refetch: () => Promise<Array<AntibodyFormat>>;
    };

export function useAntibodyFormatsQuery(): UseAntibodyFormatsQueryResult {
  const result = useBenchlingQuery<AntibodyFormatsQuery>(ANTIBODY_FORMATS_QUERY);
  const refetch = async (): Promise<Array<AntibodyFormat>> => {
    const refetchResult = await result.refetch();
    return refetchResult.data?.allAntibodyFormats ?? [];
  };
  if (result.type !== QueryResultType.SUCCESS) {
    return {status: result.type, antibodyFormats: null, refetch};
  }
  return {
    status: QueryResultType.SUCCESS,
    antibodyFormats: result.data.allAntibodyFormats,
    refetch,
  };
}
